import { render, staticRenderFns } from "./LearningIndex.vue?vue&type=template&id=fca321a2&"
import script from "./LearningIndex.vue?vue&type=script&lang=js&"
export * from "./LearningIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports